<template>
  <div class="freeissue-page">

    <!-- Page header -->
    <div class="page-header">
      <button class="back-btn" v-if="is_pin_first_use != 'Y'" onclick="window.history.back()"><i class="ft-arrow-left"></i></button>
      <button class="back-btn" v-if="is_pin_first_use == 'Y'" v-on:click="is_pin_first_use = 'N'"><i class="ft-arrow-left"></i></button>
      <div class="header-info">
        <span class="page-title" v-if="is_pin_first_use != 'Y'">Free Issue Checkout</span>
        <span class="page-title" v-if="is_pin_first_use == 'Y'">Update PIN</span>
        <span class="page-subtitle" v-if="is_pin_first_use != 'Y'">
          <i class="ft-shopping-cart"></i> {{ cart.length }} item{{ cart.length !== 1 ? 's' : '' }}
        </span>
        <span class="page-subtitle" v-if="is_pin_first_use == 'Y'">Set a new 4-digit PIN</span>
      </div>
    </div>

    <!-- Main card -->
    <div class="section-pad" id="pin-card">

      <!-- ── Checkout view ── -->
      <div v-if="is_pin_first_use != 'Y'">

        <!-- Notes -->
        <div class="form-card">
          <div class="form-card-header">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>
            Order / Delivery Notes
          </div>
          <textarea class="notes-input" id="notes" v-model="notes" rows="3" placeholder="Add any notes for this order…"></textarea>
        </div>

        <!-- PIN entry -->
        <div class="form-card">
          <div class="form-card-header">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
            Client Approval PIN
          </div>
          <p class="pin-hint">Ask the client to enter their 4-digit PIN to approve this order.</p>
          <div class="pin-row">
            <input type="password" maxlength="1" class="pin-box pin-1" v-model="pin_1" v-on:keyup="addPin(1)" placeholder="·"/>
            <input type="password" maxlength="1" class="pin-box pin-2" v-model="pin_2" v-on:keyup="addPin(2)" placeholder="·"/>
            <input type="password" maxlength="1" class="pin-box pin-3" v-model="pin_3" v-on:keyup="addPin(3)" placeholder="·"/>
            <input type="password" maxlength="1" class="pin-box pin-4" v-model="pin_4" v-on:keyup="addPin(4)" placeholder="·"/>
          </div>
          <button type="button" class="submit-btn" v-on:click="verifyPin()">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
            Approve &amp; Place Order
          </button>
        </div>

      </div>

      <!-- ── Update PIN view ── -->
      <div v-if="is_pin_first_use == 'Y'">

        <div class="form-card">
          <div class="form-card-header">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
            New PIN
          </div>
          <p class="pin-hint">Enter a new 4-digit PIN for this client.</p>
          <div class="pin-row">
            <input type="password" maxlength="1" class="pin-box pin-1" v-model="pin_1" v-on:keyup="addPin(1)" placeholder="·"/>
            <input type="password" maxlength="1" class="pin-box pin-2" v-model="pin_2" v-on:keyup="addPin(2)" placeholder="·"/>
            <input type="password" maxlength="1" class="pin-box pin-3" v-model="pin_3" v-on:keyup="addPin(3)" placeholder="·"/>
            <input type="password" maxlength="1" class="pin-box pin-4" v-model="pin_4" v-on:keyup="addPin(4)" placeholder="·"/>
          </div>
          <button type="button" class="submit-btn" v-on:click="updatePin()">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
            Save PIN
          </button>
        </div>

      </div>

    </div>

  </div>
</template>

<script>
import swal from 'sweetalert'

export default {
  name: 'freeissueorder',
  data: function () {
    return {
      cart: window.localStorage.getItem('cart') ? JSON.parse(window.localStorage.getItem('cart')) : [],
      cartBalance: 0,
      notes: '',
      signature: '',
      periods: [],
      pin_1:'',
      pin_2:'',
      pin_3:'',
      pin_4:'',
      approver:[],
      loader:false,
      showNotes:true,
      is_pin_first_use:"N",
      new_pin:"",
      confirm_pin:""
    }
  },
  mounted: function () {

    this.$store.commit('SET_LAYOUT', 'AppLayout')

    var periods = []

    this.cart.forEach(function (item) {
      periods.push({
        title: item.period_title,
        id: item.period_id
      })
    })

    // Now we filter out duplicates
    var obj = {}

    for (var i = 0, len = periods.length; i < len; i++) {
      obj[periods[i]['id']] = periods[i]
    }
    var newPeriods = []
    for (var key in obj) {
      newPeriods.push(obj[key])
    }
    this.periods = newPeriods
    this.notes = window.localStorage.getItem('notes')
    this.updatePin()
  },

  methods: {
    addPin: function(input){
      if(input == 1){
        if(this.pin_1.length > 0){
          $(".pin-2").focus()
        }
      }else if(input == 2){
        if(this.pin_2.length > 0){
          $(".pin-3").focus()
        }
      }else if(input == 3){
        if(this.pin_3.length > 0){
          $(".pin-4").focus()
        }
      }
    },
    verifyPin: function(){
        var that = this
       var postData = {
         pin:that.pin_1+that.pin_2+that.pin_3+that.pin_4
       }
      $("#pin-card").hide()
      that.loader = true
      $.showLoading()
       $.ajax({
        url: that.$config.apiUrl +'canteenapp_user/verify_app_pin',
        type: 'POST',
        data: JSON.stringify(postData),
        success: function (data) {
          that.approver = data.data
          that.pin_1 = ""
          that.pin_2 = ""
          that.pin_3 = ""
          that.pin_4 = ""
          if(data.data.is_pin_first_use != undefined){
            that.is_pin_first_use = data.data.is_pin_first_use
            if(data.data.is_pin_first_use == "Y"){
              //that.is_pin_first_use = "Y"
              console.log("that.is_pin_first_use",that.is_pin_first_use)
              $("#pin-card").show()
              return false
            }
          }
          $(".pin-1").focus()
          $.hideLoading()
          setTimeout(function(){
            that.placeOrder()
          },200)
        
        },
        error: function (error) {
          that.pin_1 = ""
          that.pin_2 = ""
          that.pin_3 = ""
          that.pin_4 = ""
          $(".pin-1").focus()
          console.log('error',error)
          swal('Error', error.responseJSON.meta.reason, 'error')
          $("#pin-card").show()
          that.loader = false
          $.hideLoading()
        }
      })
    },
    updatePin: function(){
      var that = this
      var postData = {
         pin:that.pin_1+that.pin_2+that.pin_3+that.pin_4
      }
     
      $.showLoading()
       $.ajax({
        url: that.$config.apiUrl +'basic/update_pin',
        type: 'POST',
        data: JSON.stringify(postData),
        success: function (data) {

          if(data.success){
            swal('Success', data.message, 'success').then(function () {
               that.verifyPin()
            })
          }else{
             swal('Error', data.message, 'error').then(function () {
                that.pin_1 = ""
                that.pin_2 = ""
                that.pin_3 = ""
                that.pin_4 = ""
            })
          }
          
        },
        error: function (error) {
          that.pin_1 = ""
          that.pin_2 = ""
          that.pin_3 = ""
          that.pin_4 = ""
          $.hideLoading()
        }
      })
    },
    resetPin: function(){
      var that = this
      var postData = {
         pin:"1234"
      }
     
      $.showLoading()
       $.ajax({
        url: that.$config.apiUrl +'basic/update_pin',
        type: 'POST',
        data: JSON.stringify(postData),
        success: function (data) {

          if(data.data.is_pin_first_use != undefined){
            that.is_pin_first_use = data.data.is_pin_first_use
          }
          
        },
        error: function (error) {
         
          $.hideLoading()
        }
      })
    },
    placeOrder: function () {
      
      $("#pin-card").hide()
      // $(".loader").show()
      var that = this
      var user = JSON.parse(window.localStorage.getItem('user'))
      var merchantId = user.merchant.id
      var period = JSON.parse(window.localStorage.getItem('period'))
      var date = window.localStorage.getItem('date')
      var ward = JSON.parse(window.localStorage.getItem('ward'))
      // var file = this.signature.toDataURL().slice(22)
      // var fileName = 'signature-' + this.guid() + '.png'

      var items = []
      this.cart.forEach(function (item) {
        items.push({
          id: item.mealId,
          label: item.label,
          price: item.price,
          quantity: item.quantity,
          additions: item.additions,
          exclusions: item.exclusions,
          period_id: item.period_id,
          quantity: item.quantity
        })
      })

      var Base64ImgTmp = window.localStorage.getItem('Base64ImgTmp')

      var data = {
        date: date,
        note: that.notes,
        approved_by_user_id:that.approver.id,
        ward_id: ward.ward_id,
        items: items,
        merchant_id: merchantId,
        token: localStorage.getItem('token'),
        signature: Base64ImgTmp
      }
      console.log('data',data)
      $.showLoading()
 
      $.ajax({
        url: this.$config.apiUrl +'canteenapp_orders/place_free_issues',
        type: 'POST',
        data: data,
        success: function (data) {
          that.loader = false
          $.hideLoading()
          window.localStorage.removeItem('cart')

          var date = window.localStorage.getItem('date')
          var bed = JSON.parse(window.localStorage.getItem('bed'))

          swal('Success', 'Order has been placed!', 'success').then(function () {
            that.$router.push('/')
          })
          
        },
        error: function (error) {
          console.log('error',error)
          $("#pin-card").show()
          that.loader = false
          swal('Error', error.responseJSON.meta.reason, 'error')

          $.hideLoading()
        }
      })
    }
  }
}
</script>

<style scoped>
.freeissue-page {
  min-height: 100vh;
  background: #f0f4f8;
  padding-bottom: 40px;
}

/* ── Page header ── */
.page-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 30px 20px 20px;
  background: linear-gradient(135deg, #1a587b 0%, #0f3d5c 100%);
  position: fixed;
  top: 0; left: 0;
  width: 100%;
  z-index: 10;
  margin-top: 3.2rem;
  box-shadow: 0 8px 32px rgba(15, 61, 92, 0.35);
}

.back-btn {
  width: 36px; height: 36px;
  border-radius: 10px;
  background: rgba(255,255,255,0.15);
  border: 1px solid rgba(255,255,255,0.2);
  color: #fff;
  display: flex; align-items: center; justify-content: center;
  font-size: 1rem; cursor: pointer; flex-shrink: 0;
  transition: background 0.15s;
}
.back-btn:hover { background: rgba(255,255,255,0.25); }

.header-info { display: flex; flex-direction: column; gap: 3px; }
.page-title  { font-size: 1.05rem; font-weight: 700; color: #fff; }
.page-subtitle {
  font-size: 0.73rem; color: rgba(255,255,255,0.65); font-weight: 500;
  display: flex; align-items: center; gap: 4px;
}
.page-subtitle i { font-size: 0.65rem; }

/* ── Section ── */
.section-pad {
  /* padding: 110px 16px 0; */
  max-width: 520px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* ── Form cards ── */
.form-card {
  background: #fff;
  border-radius: 16px;
  border: 1.5px solid #e8edf2;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
  overflow: hidden;
}

.form-card-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 20px;
  background: #f8fafc;
  border-bottom: 1px solid #e8edf2;
  font-size: 0.8rem;
  font-weight: 700;
  color: #334155;
  text-transform: uppercase;
  letter-spacing: 0.8px;
}
.form-card-header svg { color: #1a587b; flex-shrink: 0; }

/* ── Notes textarea ── */
.notes-input {
  width: 100%;
  padding: 14px 20px;
  border: none;
  resize: vertical;
  font-size: 0.9rem;
  color: #0f172a;
  background: #fff;
  line-height: 1.6;
  min-height: 90px;
  box-sizing: border-box;
}
.notes-input:focus { outline: none; }
.notes-input::placeholder { color: #94a3b8; }

/* ── PIN hint ── */
.pin-hint {
  font-size: 0.82rem;
  color: #64748b;
  margin: 14px 20px 4px;
  line-height: 1.5;
}

/* ── PIN boxes ── */
.pin-row {
  display: flex;
  justify-content: center;
  gap: 14px;
  padding: 16px 20px 20px;
}

.pin-box {
  width: 62px;
  height: 72px;
  border-radius: 14px;
  border: 2px solid #e2e8f0;
  background: #f8fafc;
  font-size: 1.8rem;
  font-weight: 800;
  color: #0f172a;
  text-align: center;
  transition: border-color 0.2s, box-shadow 0.2s, background 0.15s;
  -webkit-appearance: none;
  appearance: none;
}
.pin-box:focus {
  outline: none;
  border-color: #1a587b;
  background: #fff;
  box-shadow: 0 0 0 4px rgba(26, 88, 123, 0.12);
}
.pin-box::placeholder { color: #cbd5e1; font-size: 1.2rem; }

/* ── Submit button ── */
.submit-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: calc(100% - 40px);
  margin: 0 20px 20px;
  padding: 14px;
  border-radius: 12px;
  background: linear-gradient(135deg, #1a587b 0%, #0f3d5c 100%);
  border: none;
  color: #fff;
  font-size: 0.95rem;
  font-weight: 700;
  cursor: pointer;
  transition: opacity 0.15s, transform 0.1s;
  letter-spacing: 0.2px;
}
.submit-btn:hover  { opacity: 0.92; }
.submit-btn:active { transform: scale(0.98); }
</style>
